import { FormFieldTypes } from "../../../../data/formFieldType";

export const gmapApplicationTasklistFormData = {
    name: "AdditionalInfo",
    initialState: {
        name: null,
        gmapNumber: null,
        submissionDate: null,
        submissionDateEnd: null,
        status: null
    },
    formFields: [
        {
            id: "name",
            lable: "Name/GMP Number/Email",
            Field_Name: "NaName/GMAP Numberme",
            fieldType: FormFieldTypes.INPUT,
            dataField: "name",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-4 col-xl-4 col-md-4 col-sm-12 col-12",
            },
        },
        {
            id: "status",
            lable: "Status",
            Field_Name: "Status",
            fieldType: FormFieldTypes.SELECT,
            dataField: "status",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            style: {
                containerCss: "col-lg-4 col-xl-4 col-md-4 col-sm-12 col-12"
            }
        },
        {
            id: "source",
            lable: "Source",
            Field_Name: "Source",
            fieldType: FormFieldTypes.SELECT,
            dataField: "source",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            style: {
                containerCss: "col-lg-4 col-xl-4 col-md-4 col-sm-12 col-12"
            }
        },

    ],
    formSetting: {
        isViewOnly: false
    }
}